"use client";

import { create } from "zustand";
import type { HeaderVariantKey } from "@dionatanbig2be/big2be-ui";

/** Aparência do modal fornecida pela variante do Header que o abriu — usada
 * pra escolher o SearchGroup certo (HeaderVariant{1,2,3}SearchGroup) e a
 * cor (inverted), mantendo o campo do modal idêntico ao do header real. */
export interface SearchFullscreenPresentation {
    variant: HeaderVariantKey;
    inverted: boolean;
}

interface SearchFullscreenState {
    open: boolean;
    presentation: SearchFullscreenPresentation;
    openModal: (presentation: SearchFullscreenPresentation) => void;
    close: () => void;
}

/**
 * Estado do modal de busca fullscreen mobile — mesmo padrão do
 * useStoreSwitcher/useHeaderCategoryPanel. Acionado pelo campo de busca do
 * header no mobile (o input real mora dentro do modal, não no header). O
 * modal monta o SearchGroup correspondente à `variant` ativa, garantindo que
 * o campo seja visualmente idêntico ao do header.
 */
export const useSearchFullscreen = create<SearchFullscreenState>()((set) => ({
    open: false,
    presentation: { variant: "variant-1", inverted: false },
    openModal: (presentation) => set({ open: true, presentation }),
    close: () => set({ open: false }),
}));
